<template>
  <div>
    <div>
      <p>
        {{ locale.bankruptDebts.totalCount }}
        <strong class="totalCount">
          {{ pagination.totalCount ? pagination.totalCount : 0 }}
        </strong>

        {{ locale.bankruptDebts.totalCountDebt }}
        <strong class="totalCount">
          {{ totalSum ? totalSum : 0 }}
        </strong>

        {{ locale.bankruptDebts.totalCountDebtGuaranteed }}
        <strong class="totalCount">
          {{ totalSumGuaranteed ? totalSumGuaranteed : 0 }}
        </strong>
      </p>
    </div>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="partyTypeId"
          :items="partyTypesBankRuptcyFile"
          item-text="name"
          item-value="id"
          class="radio-button-option-v1"
          @change="changePartyType"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="bankruptDebts.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
          <template slot-scope="{item}">
            <v-icon
              color="primary"
              @click="showModal(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </naj-data-table>
      </v-col>
    </v-row>
    <naj-modal
      ref="bankruptDebtModal"
      :title="`${locale.bankruptDebts.bankruptDebt}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <bankrupt-debt
        :form-model="formModel"
        :loading="loading"
      ></bankrupt-debt>
    </naj-modal>
  </div>
</template>
<script>

import BankruptDebt from './bankrupt-debt.vue';
import { createNamespacedHelpers } from 'vuex';
import { toHijriDate } from '@/helpers/utils';
import { partyTypeEnum } from '../../../../helpers/enum';
const { mapActions, mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { BankruptDebt },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      toHijriDate,
      loading: false,
      bankruptDebts: { list: [] },
      formModel: {},
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'name',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.name,
        },
        {
          value: 'remainingPayment',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.debtValue,
        },
        {
          value: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.dueDate,
        },
        {
          value: 'action',
          text: '',
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      totalSum: 0,
      totalSumGuaranteed: 0,
      partyTypeEnum,
      partyTypeId: partyTypeEnum.person,
    };
  },
  computed: { ...mapLUTState(['partyTypesBankRuptcyFile']) },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['getBankruptDebtsByRequestObjectKey', 'getBankruptDebt']),
    importDataHandler() { },
    loadData() {
      this.loading = true;
      this.totalSum = 0;
      this.totalSumGuaranteed = 0;
      this.getBankruptDebtsByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        partyTypeId: this.partyTypeId,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.bankruptDebts = { ...data };
          this.bankruptDebts.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });
          if (this.bankruptDebts.list.length) {
            this.totalSum = this.bankruptDebts.list[0].totalSum;
            this.totalSumGuaranteed = this.bankruptDebts.list[0].totalSumGuaranteed;
          }
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.loadData();
    },
    showModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getBankruptDebt(params)
        .then((res) => {
          this.formModel = res.data;
          this.$refs.bankruptDebtModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
    },
    changePartyType() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
.totalCount {
  padding: 6px;
  margin-right: 2px;
  margin-left: 13px;
  background-color: black;
  font-size: 13px;
  color: white;
}
div p {
  font-size: 15px;
}
.options-list {
  display: flex;
}

::v-deep .radio-button-option-v1 {
  .v-input--radio-group {
    .radio-button-option {
      background: #fff;
      border-top: 0px solid #fff;
      border-bottom: 0px solid #fff;
      &:first-child {
        border-right: 0px solid #fff;
      }
      &:last-child {
        border-left: 0px solid #fff;
      }
    }
  }
}
</style>
